
<div>
  <label>Billing</label>
  <div class="form-row">
    <div class="col">
      <select v-model="contract.billing.type"
              class="form-control text-capitalize form-control-sm"
              :disabled="disabled">
        <option class="text-capitalize"
                v-for="(o, i) in summary.options(`billing`, `type`)"
                :key="i">
          <span class="text-capitalize" v-text="o"></span>
        </option>
      </select>
      <small class="form-text text-muted">Billing Type</small>
    </div>
    <div class="col">
      <select v-model="contract.billing.schedule"
              class="form-control form-control-sm"
              :disabled="disabled">
        <option v-for="(o, i) in summary.options(`billing`, `schedule`)"
                :key="i">
          <span v-text="o"></span>
        </option>
      </select>
      <small class="form-text text-muted">Billing Schedule</small>
    </div>
    <div class="col">
      <select v-model="contract.billing.values"
              class="form-control form-control-sm"
              :disabled="summary.disabled(`billing`, `values`)">
        <option v-for="(o, i) in summary.options(`billing`, `values`)"
                :key="i">
          <span v-text="o"></span>
        </option>
      </select>
      <small class="form-text text-muted">Billing Values</small>
    </div>
  </div>
</div>
